import React from "react";

export default function Hero({ onContactClick }) {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-purple-900">
      
      {/* Radial gradient patterns */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "radial-gradient(circle at 25% 25%, #c084fc 0%, transparent 50%), radial-gradient(circle at 75% 75%, #a855f7 0%, transparent 50%)",
        }}
      />

      {/* Main content */}
      <div className="relative z-10 text-center px-4 sm:px-6 max-w-4xl mx-auto">
        
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-purple-600/20 border border-purple-400/30 text-purple-300 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-6 md:mb-8">
          Chartered Certified Accountants Since 2001
        </div>

        {/* Heading */}
        <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold text-white leading-tight mb-4 md:mb-6 drop-shadow-lg">
          BakerKerry
          <span className="block text-purple-400">Accountants</span>
        </h1>

        {/* Paragraph */}
        <p className="text-base sm:text-lg md:text-xl text-slate-300 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Expert financial guidance for individuals and businesses. Trusted by our clients for over two decades of dedicated accountancy excellence.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
          <button
            onClick={onContactClick}
            className="bg-purple-600 hover:bg-purple-500 text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:shadow-lg hover:shadow-purple-600/30 w-full sm:w-auto"
          >
            Book a Free Consultation
          </button>
          <button
            onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })}
            className="border border-white/30 hover:border-white/60 text-white font-semibold px-8 py-4 rounded-full transition-all duration-300 hover:bg-white/10 w-full sm:w-auto"
          >
            Our Services
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50 text-xs tracking-widest">
        <span>SCROLL</span>
        <div className="w-px h-10 bg-gradient-to-b from-white/50 to-transparent animate-pulse" />
      </div>
    </section>
  );
}